import {
  SET_CONTENT,
  SHOW_DIALOG,
  SET_RESOLVE,
  RESET_STATE
} from "./constants.js";
import { initialState } from "./index.js";

export default {
  [SET_CONTENT](
    state,
    {
      title,
      text,
      cancelText,
      onSelection,
      onCancel,
      maxWidth,
      selection,
      hasFilter,
      icon,
      layer
    }
  ) {
    state.dialogTitle = title;
    state.dialogText = text;
    state.cancelText = cancelText;
    state.onSelection = onSelection;
    state.onCancel = onCancel;
    state.maxWidth = maxWidth;
    state.selection = selection;
    state.hasFilter = hasFilter;
    state.icon = icon;
    state.layer = layer;
  },
  [SHOW_DIALOG](state, newState) {
    state.showDialog = newState;
  },
  [SET_RESOLVE](state, newResolve) {
    state.resolve = newResolve;
  },
  [RESET_STATE](state) {
    Object.assign(state, initialState());
  }
};
